import { HttpClient, TokenCreator } from '@amzn/dots-core-ui';
import { ProjectApi, ProjectClient } from './projects';

export * from './projects';
export * from './builds';
export * from './buildFiles';
export * from './models';

export interface StorageApi {
  projects: ProjectApi;
}

export const createStorageClient = (
  storageApiUrl: string,
  createToken: TokenCreator
): StorageApi => {
  const client = new HttpClient(storageApiUrl, createToken);
  return {
    projects: ProjectClient(client),
  };
};
